import { render, staticRenderFns } from "./PlanInfoDetails.vue?vue&type=template&id=1cfa6f8a&scoped=true"
import script from "./PlanInfoDetails.vue?vue&type=script&lang=js"
export * from "./PlanInfoDetails.vue?vue&type=script&lang=js"
import style0 from "./PlanInfoDetails.vue?vue&type=style&index=0&id=1cfa6f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfa6f8a",
  null
  
)

export default component.exports